import { render, staticRenderFns } from "./detallePedido.vue?vue&type=template&id=dea83320&scoped=true&"
import script from "./detallePedido.vue?vue&type=script&lang=js&"
export * from "./detallePedido.vue?vue&type=script&lang=js&"
import style0 from "./detallePedido.vue?vue&type=style&index=0&id=dea83320&prod&lang=css&"
import style1 from "./detallePedido.vue?vue&type=style&index=1&id=dea83320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea83320",
  null
  
)

export default component.exports